import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../../store/core/url/customizeHttpUrlGenerator";
import {Payload} from "../../../../../core/service/payload/payload";

@Injectable()
export class PartnerRemoveSimilarService extends AbstractActionService<PartnerRemoveSimilarPayload, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('Partner', 'remove-similar', customizeHttpUrlGenerator, httpClient);
    }
}

export class PartnerRemoveSimilarPayload implements Payload {
    partnerId1: number;
    partnerId2: number;
}